import { colors as palette } from '@plataforma/components';

const colorsComplementary = {
  greenLight: '#e1f8f0',
  redLight: '#ffd8d8',
  orangeLight: '#ffe7db',
  grayLight: '#f3f3f3',
  blueLight: '#def7ff',
  bluishGrey: '#859099',
  purpleLight: '#f1eaff',
  electricViolet: '#9000FF'
};

const colors = {
  main: palette.periwinkle,
  divider: palette.cloudyBlue,
  background: palette.white,
  surface: palette.paleGrey,

  textMain: palette.slate,
  textComplementary: palette.blueyGrey,
  textOption: palette.bluishGrey,
  textAlternative: '#180a33',

  baseGreen: palette.greenishTeal,
  baseRed: palette.salmon,
  baseOrange: palette.apricot,
  baseGray: palette.blueyGrey,
  baseBlue: palette.brightLightBlue,
  basePurple: palette.periwinkle,

  baseGreenLight: colorsComplementary.greenLight,
  baseRedLight: colorsComplementary.redLight,
  baseOrangeLight: colorsComplementary.orangeLight,
  baseGrayLight: colorsComplementary.grayLight,
  baseBlueLight: colorsComplementary.blueLight,
  basePurpleLight: colorsComplementary.purpleLight,
  baseElectricViolet: colorsComplementary.electricViolet
};

export default colors;
